import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppConfig {
	private config: any;

	constructor(private httpBackend: HttpBackend) {}

	public get(key: any) {
		const value = this.config[key];
		if (value === undefined) {
			console.error(`Chiave ${key} non trovata nel file di configurazione!`);
		}
		return this.config[key];
	}

	public load() {
		const http = new HttpClient(this.httpBackend);
		return http
			.get('./assets/config/config.json')
			.pipe(
				tap((config: any) => {
					this.config = config;
					console.log('CONFIG', config);
				}),
				catchError(() => {
					console.error('File di configurazione assets/config/config.json non trovato!');
					return of();
				}),
			)
			.toPromise();
	}
}
